module.exports = __webpack_public_path__ + "static/media/sakura.3133a43c.jpeg";